import XlsxPopulate from 'xlsx-populate'
import { saveAs } from 'file-saver'

export const saveAsExcel = (data, fileName, object, headers, orderCustomSecurity) => {
    const getSheetData = (data, header) => {
        var sheetData = []
        if (data && data.length) {
            var fields = Object.keys(data[0])

            sheetData = data.map(function (row) {
                return fields.map(function (fieldName) {
                    return row[fieldName] ? row[fieldName] : ''
                })
            })
        }
        sheetData.unshift(header)
        return sheetData
    }

    let header = headers

    data = data.map((x) => {
        delete x.SaveError
        return { ...object, ...x }
    })
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0)
        const sheetData = getSheetData(data, header)
        const totalColumns = sheetData[0].length
        const maxRowsAllowed = 100 // Máximo de órdenes permitidas por carga

        sheet1.cell('A1').value(sheetData)

        const maxStringLength = rango => sheet1.range(rango).reduce((max, cell) => {
            const value = cell.value();
            if (value === undefined) return max;
            return Math.max(max, value.toString().length + 2);
        }, 0);

        const columns = Array.from(new Set(Array(totalColumns).fill().map((_, i) => String.fromCharCode(65 + i))))
        columns.forEach(column => {
            sheet1.column(column).width(maxStringLength(column + '1:' + column + '1000'));
        })

        if (fileName === 'Ordenes.xlsx') {
            const commonInfo = sheet1.range("A1:U1")
            const shipmentInfo = sheet1.range("J1:K1")
            const lockerInfo = sheet1.range("L1:P1")
            const depositColumn = sheet1.cell("Q1")

            commonInfo.style('fill', 'BFBFBF')
            shipmentInfo.style('fill', 'a9d08e')
            lockerInfo.style('fill', '9bc2e6')
            depositColumn.style('fill', 'f7b500')

            if (orderCustomSecurity) {
                const securityInfo = sheet1.range("R1:U1")
                securityInfo.style('fill', 'BFBFBF')
            }

        } else if (fileName === 'Plantilla ejemplo de órdenes Pudo' || fileName === 'Ordenes no creadas') {
            const commonInfo = sheet1.range("A1:D1")
            const lockerInfo = sheet1.range("E1:I1")
            const shipmentInfo = sheet1.range("J1:P1")
            const depositColumn = sheet1.cell("Q1")
            commonInfo.style('fill', 'BFBFBF')
            lockerInfo.style('fill', '9bc2e6')
            shipmentInfo.style('fill', 'a9d08e')
            depositColumn.style('fill', 'f7b500')

            if (orderCustomSecurity) {
                const securityInfo = sheet1.range("R1:U1")
                securityInfo.style('fill', 'BFBFBF')
            }
        }

        function applyDataValidation(range, options) {
            sheet1.range(range).dataValidation({
                type: 'list',
                formula1: `"${options.join(',')}"`,
                showDropDown: true
            });
        }

        if (orderCustomSecurity) {
            const typeOptions = ['Dni', 'Alphanumeric', '']
            const booleanOptions = ['true', 'false', '']
            applyDataValidation(`T2:T${maxRowsAllowed}`, typeOptions)
            applyDataValidation(`R2:R${maxRowsAllowed}`, booleanOptions)
            applyDataValidation(`S2:S${maxRowsAllowed}`, booleanOptions)

            sheet1.column('R', 'S').style({ numberFormat: '@' })
        }

        const range = sheet1.usedRange()
        sheet1.row(1).style('bold', true)
        range.style('border', true)
        return workbook.outputAsync().then((res) => {
            saveAs(res, fileName)
        })
    })
}